import React from 'react';

const About = () => {

  const values = [
    {
      title: '专业创新',
      description: '持续关注前沿技术，为客户提供最专业的解决方案',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      )
    },
    {
      title: '质量至上',
      description: '严格的质量控制体系，确保每个项目的高质量交付',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
        </svg>
      )
    },
    {
      title: '客户导向',
      description: '以客户需求为中心，提供个性化的服务体验',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      )
    }
  ];

  return (
    <section id="about" className="bg-white section-padding">
      <div className="container-max">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
                关于我们
              </h2>
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  BioZen 是一家专注于生物信息学数据分析和软件开发的创新型公司。
                  我们致力于为科研机构、医院和制药企业提供专业、高效的生物信息学解决方案。
                </p>
                <p>
                  凭借多年的行业经验和技术积累，我们的团队在多组学数据分析、临床数据挖掘、
                  生物标志物发现等领域具有深厚的专业知识和丰富的项目经验。
                </p>
              </div>
            </div>

            {/* Mission */}
            <div className="bg-primary-50 rounded-xl p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">我们的使命</h3>
              <p className="text-gray-700 leading-relaxed">
                通过先进的生物信息学技术和创新的软件工具，加速生物医学研究的进展，
                为人类健康事业贡献我们的专业力量。
              </p>
            </div>
          </div>     
     {/* Right Content */}
          <div className="space-y-8">
            {/* Values */}
            <div className="space-y-6">
              <h3 className="text-xl font-semibold text-gray-900">核心价值观</h3>
              {values.map((value, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center text-primary-600 flex-shrink-0">
                    {value.icon}
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">
                      {value.title}
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {value.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default About;